export type SHSignatureCategory = "APPROVE" | "CANCEL" | "REMINDER" | "SUBMIT";

export type SHSignatureProvider = "assently" | "scrive";

export type SHSignatureMethodType =
    | "BANK_ID"
    | "ID_PHOTO"
    | "MANUAL_SIGN"
    | "REMOTE_BANK_ID"
    | "REMOTE_ONE_TIME_PIN_AND_BANK_ID"
    | "SIGN_ONLY";

export type SHSignStatus =
    | "awaiting_approval"
    | "awaiting_identity_picture"
    | "awaiting_manual_confirmation"
    | "awaiting_signed_document"
    | "canceled"
    | "closed"
    | "document_error"
    | "pending"
    | "queued_for_automatic_closure"
    | "rejected"
    | "signed"
    | "ssn_validation_failed";

export const SIGN_STATUS_LABELS: Record<SHSignStatus, string> = {
    awaiting_approval: "Venter på godkjenning",
    awaiting_identity_picture: "Venter på bilde av legitimasjon",
    awaiting_manual_confirmation: "Venter på manuell bekreftelse",
    awaiting_signed_document: "Venter på signert dokument",
    canceled: "Avbrutt",
    closed: "Signering fullført",
    document_error: "Dokumentfeil",
    pending: "Venter på signering",
    queued_for_automatic_closure: "Signering fullføres",
    rejected: "Avvist",
    signed: "Signering fullført",
    ssn_validation_failed: "Validering av personnummer feilet",
};

export interface SHSignDocReply {
    session_id?: string;
    signatory_parties: Array<{
        email?: string;
        msisdn?: string;
        signature_method: SHSignatureMethodType;
    }>;
    signature_category: SHSignatureCategory;
    signature_provider?: SHSignatureProvider;
    status: SHSignStatus;
}

export interface SHSignStatusReply {
    session_id: string;
    signatory_parties: Array<{
        email?: string;
        msisdn?: string;
        signature_method: SHSignatureMethodType;
    }>;
    signature_category: SHSignatureCategory;
    signature_provider: SHSignatureProvider;
    status: SHSignStatus;
}

export interface SHSignatureMethod {
    signature_method: SHSignatureMethodType;
}

export type SHSignatureMethodsReply = SHSignatureMethod[];

export interface SHAcceptSignatureReply {
    session_id: string;
    signature_category: SHSignatureCategory;
    status: SHSignStatus;
}

export interface SHConfirmManualSignatureReply {
    session_id: string;
    signature_category: SHSignatureCategory;
    status: SHSignStatus;
}
